// extracted by mini-css-extract-plugin
module.exports = {"hidingHeader":"RestaurantTag_hidingHeader__hFENd","hidingHeader-in":"RestaurantTag_hidingHeader-in__p_QZ7","wrapper":"RestaurantTag_wrapper__mIdh0"};